<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="(menu, menuCount) in menus" >
            <v-list-group
            :key="menu.pageTypeDesc"
            prepend-icon="mdi-chevron-down"
            append-icon=""
            dense
            style="background-color:#1565C0;text-color:white;color:white;font-color:white"
            class="pa-0"
          >
            <template v-slot:activator>
              <v-list-item-content >
                <v-list-item-title style="color:white;">
                  {{ menu.group }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(child, i) in menu.items"
              :key="i"
              link
              style="background-color:white;"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon style="color:white!important;">{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content v-on:click="itemClick(child.path)">
                <v-list-item-title class="pl-8">
                  &nbsp;&nbsp; {{ child.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            </v-list-group>
            <v-divider :key="menuCount" class="my-0"/>
        </template>
      </v-list>
    </v-navigation-drawer>
 
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      style="padding-right:20px"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-avatar :tile="true">
        <v-img src="@/assets/skg-logo.png" aspect-ratio="1" ></v-img>
      </v-avatar>
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4 d-flex child-flex"
      >
        <span class="hidden-sm-and-down">SK Group</span>
      </v-toolbar-title>
      <v-spacer />
    <v-menu open-on-hover bottom  offset-y>
      <template v-slot:activator="{ on, attrs }">
         <v-avatar color="indigo">
          <v-icon dark>mdi-account-circle</v-icon>
        </v-avatar>
        <v-btn
          text
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{username}}
        </v-btn>
        
      </template>
      <v-list>
        <v-list-item key="changePass" @click="changePass()">
          <v-list-item-title>
            เปลี่ยนรหัสผ่าน
          </v-list-item-title>
        </v-list-item>
        <v-list-item key="logout"  @click="doLogout()">
          <v-list-item-title>
            ออกจากระบบ
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      
    </v-app-bar>
   
   <v-dialog v-model="modal" max-width="400px" persistent >
        <v-card>
            <v-card-title primary-title> 
                <b>เปลี่ยนรหัสผ่าน</b> </v-card-title>        
            <v-divider></v-divider>    
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field :rules="[rules.required]" autofocus label="รหัสผ่านใหม่" type="password" v-model="password" @keyup.enter.native="doLogin"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
           <v-divider></v-divider>   
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="primary" v-on:click="save">ตกลง</v-btn>
                <v-btn color="primary" v-on:click="close">ยกเลิก</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>

  
</template>

<script>
/* eslint-disable */

import {logout} from '@/api/authen-api.js'
import {getUser} from '@/assets/js/common.js'
import {changePassword} from '@/api/master/user-api.js'

export default {
  name: 'SecMenuHeader',
  props: ["userName", "userImg"],
   computed: {
    username() {
      return this.$store.state.username ?  this.$store.state.username : getUser();
    }
  },
  data() {
      return {
          modal: false,
          drawer: false,
          password: '',
          menus: [
            { group: "ข้อมูลหลัก", items: [
                {name: "บริษัทในเครือ", path: "company"},
                {name: "สาขา", path: "branch"},
                {name: "ตำแหน่ง", path: "position"},
                {name: "ผู้ใช้งานระบบ", path: "user"},
                {name: "กลุ่มผู้ใช้งาน", path: "group"},
                {name: "ข้อมูลพนักงาน", path: "employee"},
                {name: "ข้อมูลลูกค้า", path: "customer"},
                {name: "ข้อมูลรถลูกค้า", path: "car"},
                {name: "หน้าจอระบบซ่อมตัวถังและสี", path: "page"},
                {name: "ประกัน และส่วนลด", path: "insurance"},
                {name: "ผู้ผลิด/ผู้จำหน่าย", path: "supplier"},
                {name: "อะไหล่", path: "part"},
                {name: "วัสดุสิ้นเปลือง", path: "consumable"},
                {name: "รายการซ่อม", path: "service"},
                {name: "ยี่ห้อรถ", path: "brand"},
                {name: "รุ่นรถ", path: "model"},
                {name: "สีรถ", path: "color"}
              ]
            },
            { group: "จัดการสิทธ์", items: [
                {name: "ผู้ใช้งานแต่ละสาขา", path: "user-branch"},
                {name: "หน้าจอแต่ละกลุ่ม", path: "page-group"}
              ]
            },
          ],
          rules: {
            required: value => !!value || 'Required.'
        }
      }
  },
  methods: {
      itemClick(location) {
        this.$router.push(location);
      },
      doLogout() {
        logout(this.userName).then(() => {
          localStorage.removeItem("key");
          window.location = "/";
        }).catch((e) => {
          console.log(e);
        });
      },
      changePass() {
        this.modal = true;
      },
      save() {
            changePassword(this.username, this.password).then(rs => {
                this.close();
            });
        },
        close() {
            this.modal = false;
            this.password = '';
            this.$loading(false);
        }
  }
};
</script>